module.exports = __webpack_public_path__ + "img/icon_fileXXXXL.e268e269.svg";